import React from 'react';


const Social = () => {
    return (
        <div className='home_social'>

        <a href='https://github.com/sumitgit2' className='home_social-icon' target='_blank'><i className="uil uil-github"></i></a>

        <a href='https://www.instagram.com/mr__sumit__2.0?igsh=dXllZGUwdzNpdWls' className='home_social-icon' target='_blank'><i className="uil uil-instagram"></i></a>

        <a href='https://api.whatsapp.com/send?phone=+916205523370&text=Hi%20Sir%20!' className='home_social-icon' target='_blank'><i className="uil uil-whatsapp"></i></a>

        <a href='https://www.linkedin.com/in/sumitdev83/' className='home_social-icon' target='_blank'><i className="uil uil-linkedin"></i></a>


        </div>
    );
}

export default Social;
